import { fork, take, call, put, select } from 'redux-saga/effects';
import { get } from 'lodash';

import { formatAmount } from '@shared/helpers';

import {
	TRANSACTION_DETAIL_ERROR,
	TRANSACTION_DETAIL_REQUESTING,
	TRANSACTION_DETAIL_SUCCESS,
	REFUND_TRANSACTION_REQUESTING,
	REFUND_TRANSACTION_SUCCESS,
	REFUND_TRANSACTION_ERROR,
	CASHBACK_DETAIL_REQUESTING,
	CASHBACK_DETAIL_SUCCESS,
	CASHBACK_DETAIL_ERROR,
} from '@/redux/ducks/trasnasctionDetail/types';
import { INIT_APP_ERROR } from '@/redux/ducks/init/types';
import { SHOW_TOAST } from '@/redux/ducks/toast/types';
import Api from '@/data';

export const merchantProfile = (state) => state.merchantProfile;

const getUnitIdFromStore = (state) =>
	get(state, 'transactionDetail.detailData.data.unitId');

// Get the transaction detail data
export function* fetchCashbackDetail(response) {
	try {
		yield put({ type: CASHBACK_DETAIL_REQUESTING });
		const cashbackResponse = yield call(Api.getTransactionDetail, {
			transactionId: response.transactionId,
			merchantIds: [get(response, 'merchantDetails.merchantId')],
			userId: get(response, 'customerDetails.userId'),
			transactionTypeFilters: ['CASHBACK_TRANSACTION'],
		});
		if (cashbackResponse.data.success) {
			yield put({
				type: CASHBACK_DETAIL_SUCCESS,
				data: cashbackResponse.data.data,
			});
		} else {
			yield put({
				type: CASHBACK_DETAIL_ERROR,
				error: { message: 'Something went wrong.' },
			});
		}
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: CASHBACK_DETAIL_ERROR, error: error.data });
			yield put({
				type: SHOW_TOAST,
				payload: { msg: get(error, 'data.message'), type: 'error' },
			});
		}
	}
}

export function* fetchTransactionsDetail(payload) {
	try {
		yield put({ type: TRANSACTION_DETAIL_REQUESTING });
		const response = yield call(Api.getTransactionDetailByUnitId, payload);
		yield put({ type: TRANSACTION_DETAIL_SUCCESS, data: response.data });
		if (get(response, 'data.data.cashbackApplied')) {
			yield call(fetchCashbackDetail, response.data.data);
		}
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: TRANSACTION_DETAIL_ERROR, error: error.data });
			yield put({
				type: SHOW_TOAST,
				payload: { msg: get(error, 'data.message'), type: 'error' },
			});
		}
	}
}

export function* getTransactionsDetail() {
	while (true) {
		const payload = yield take(TRANSACTION_DETAIL_REQUESTING);
		yield call(fetchTransactionsDetail, payload.payload);
	}
}

// Refund the transaction
export function* postRefundTransaction(refundPayload) {
	try {
		yield put({ type: REFUND_TRANSACTION_REQUESTING });
		const response = yield call(Api.refundTransaction, refundPayload);
		yield put({ type: REFUND_TRANSACTION_SUCCESS, data: response.data });

		if (response.data.code === 'PAYMENT_ERROR') {
			yield put({
				type: SHOW_TOAST,
				payload: {
					msg: get(response, 'data.data.errorMessage', 'Refund failed'),
					type: 'error',
				},
			});
		} else {
			const msg = `The refund request for ${formatAmount(
				refundPayload.amount,
			)} has been sent and status will be updated shortly.`;
			yield put({ type: SHOW_TOAST, payload: { msg } });
			const unitId = yield select(getUnitIdFromStore);
			yield put({
				type: TRANSACTION_DETAIL_REQUESTING,
				payload: unitId,
			});
		}
	} catch (error) {
		if (error.status === 401) {
			yield put({ type: INIT_APP_ERROR, error: error.data });
		} else {
			yield put({ type: REFUND_TRANSACTION_ERROR, error: error.data });
			yield put({
				type: SHOW_TOAST,
				payload: { msg: get(error, 'data.message'), type: 'error' },
			});
			const unitId = yield select(getUnitIdFromStore);
			yield put({
				type: TRANSACTION_DETAIL_REQUESTING,
				payload: unitId,
			});
		}
	}
}

export function* refundTransaction() {
	while (true) {
		const payload = yield take(REFUND_TRANSACTION_REQUESTING);
		yield call(postRefundTransaction, payload.payload);
	}
}

function* transactionDetailFlowSaga() {
	yield fork(getTransactionsDetail);
	yield fork(refundTransaction);
}

export default transactionDetailFlowSaga;
